import React from 'react';
import { Button } from './ui/button';
import { LightningBoltIcon } from '@radix-ui/react-icons';
import NotificationBell from './NotificationBell';

const TopBar = ({ title, onGenerateClick }) => {
    return (
        <div className="flex items-center gap-4 h-[10%] min-h-[72px] flex-shrink-0">
            <div className="flex-1">
                <h1 className="scroll-m-20 text-2xl font-semibold tracking-tight bg-gradient-to-r from-zinc-50 to-zinc-400 bg-clip-text text-transparent">
                    {title}
                </h1>
            </div>
            <div className="flex items-center gap-3">
                <button
                    onClick={onGenerateClick}
                    className="group flex items-center gap-2 px-5 py-2 rounded-full bg-gradient-to-r from-violet-600 to-blue-600 hover:from-violet-500 hover:to-blue-500 text-white font-medium text-sm shadow-md shadow-violet-500/25 hover:shadow-violet-500/40 transition-all duration-300 hover:scale-105 active:scale-95"
                >
                    <LightningBoltIcon className="h-4 w-4 text-yellow-400 drop-shadow-[0_0_4px_rgba(250,204,21,0.8)] group-hover:animate-pulse" />
                    Generate Article
                </button>
                <NotificationBell />
            </div>
        </div>
    );
};

export default TopBar;
